export * from "@langchain/classic/stores/doc/in_memory";
